import React, { useState, useContext } from "react";
import {
  Typography,
  Stack,
  TextField,
  Button,
  InputAdornment,
  Avatar,
} from "@mui/material";
import { useMutation } from "@apollo/client";
import { useFormik, Form, FormikProvider } from "formik";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
//Srcs
import "./login.scss";
import { AuthContext } from "../Context/AuthContext";
import loginImage from "../Assets/School_logo.svg";
import { USER_LOGIN } from "../Schema/User";

export default function Login() {
  const navigate = useNavigate();
  const { setAlert, dispatch } = useContext(AuthContext);
  const [iconReload, setIconReload] = useState(false);

  // hide password hook
  const [show, setShow] = useState(false);
  const handleClick = () => setShow(!show);

  const [userLogin] = useMutation(USER_LOGIN, {
    onCompleted: ({ userLogin }) => {
      // console.log("userLogin::", userLogin)
      if (userLogin?.status && userLogin?.isNeedToChangePassword) {
        setAlert(true, "success", userLogin?.message);
        window.localStorage.setItem("token", JSON.stringify(userLogin?.token));

        setTimeout(() => {
          setIconReload(false);
          navigate("/change-password-after-reset");
          window.location.reload();
        }, 1000);
      } else if (
        userLogin?.isNeedToChangePassword === false &&
        userLogin?.status === true
      ) {
        setAlert(true, "success", userLogin?.message);
        window.localStorage.setItem("token", JSON.stringify(userLogin?.token));
        window.localStorage.setItem("role", JSON.stringify(userLogin?.role));
        dispatch({
          type: "LOGGED_IN_USER",
          payload: {
            email: "customtoken@user.com",
            token: userLogin?.token,
          },
        });

        setTimeout(() => {
          setIconReload(false);
          navigate("/dashboard");
          window.location.reload();
        }, 1000);
      } else {
        setAlert(true, "error", userLogin?.message);
        setIconReload(false);
      }
    },
    onError: (err) => {
      setAlert(true, "error", err?.message);
    },
  });

  const LoginSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email!").required("Required"),
    password: Yup.string()
      .required("Required")
      .min(8, "Password must be 8 characters!"),
    client: Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      client: "Accounting",
    },

    validationSchema: LoginSchema,
    onSubmit: async (values) => {
      // console.log("values::", values);
      setIconReload(true);
      userLogin({
        variables: {
          ...values,
        },
      });
    },
  });

  const { errors, touched, handleSubmit, getFieldProps } = formik;

  return (
    <Stack
      direction="column"
      justifyContent="center"
      className="login-container"
    >
      <Stack direction="row" justifyContent="center" sx={{ width: "100%" }}>
        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <Stack direction="column" className="box-container" spacing={3}>
              <Stack direction="column" spacing={1}>
                <Stack direction="row" justifyContent="center">
                  <Avatar
                    sx={{ width: 100, height: 100 }}
                    variant="square"
                    alt="logo"
                    src={loginImage}
                  />
                </Stack>
                <Typography
                  variant="body2"
                  align="center"
                  className="login-subtitle"
                >
                  Accounting Management
                </Typography>
              </Stack>

              <Stack
                direction="column"
                justifyContent="center"
                width="100%"
                className="box-login"
                spacing={2}
              >
                <Stack direction="column">
                  <Typography className="label-login">Email</Typography>
                  <TextField
                    fullWidth
                    size="small"
                    className="input-login"
                    placeholder="example@company.com"
                    {...getFieldProps("email")}
                    error={Boolean(touched.email && errors.email)}
                    helperText={touched.email && errors.email}
                  />
                </Stack>
                <Stack>
                  <Typography className="label-login">Password</Typography>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="password"
                    type={show ? "text" : "password"}
                    {...getFieldProps("password")}
                    error={Boolean(touched.password && errors.password)}
                    helperText={touched.password && errors.password}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start" onClick={handleClick}>
                          {show ? (
                            <VisibilityIcon className="viewpw-icon" />
                          ) : (
                            <VisibilityOffIcon className="viewpw-icon" />
                          )}
                        </InputAdornment>
                      ),
                    }}
                  />
                </Stack>
                {/* <Link to="/forgotpassword">
                  <Typography className="forgot-pwd">
                    Forgot password?
                  </Typography>
                </Link> */}
              </Stack>
              <Stack direction="column">
                <Button
                  className="btn-sign-in"
                  type="submit"
                  endIcon={
                    iconReload ? (
                      <CircularProgress sx={{ color: "#fff" }} size="20px" />
                    ) : null
                  }
                >
                  Sign In
                </Button>
              </Stack>
              <Typography className="footer-copy-right">
                Copyright © 2023 Go Global IT. All rights reserved.
              </Typography>
            </Stack>
          </Form>
        </FormikProvider>
      </Stack>
    </Stack>
  );
}
